import { StickyHeader } from './StickyHeader';
import { Header } from './Header';
import React, { useEffect, useState } from 'react';
import { Fields } from './Fields';
import { useScrollbar } from '../../hooks/useScrollbar';
import { useCreateOperator } from '../../contexts/CreateOperatorContext';

export const Form = () => {
  const { creatingOperator } = useCreateOperator();
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const { scrollbarRef } = useScrollbar();
  const classes = useStyles();

  useEffect(() => {
    if (scrollbarRef.current && ref)
      scrollbarRef.current.addEventListener('scroll', () => {
        const overflowing = (scrollbarRef.current?.scrollTop ?? 0) > 100;
        if (overflowing) setShowStickyHeader(true);
        else setShowStickyHeader(false);
      });
  }, [scrollbarRef, ref]);

  if (creatingOperator) return null;

  return (
    <div className={classes.container}>
      <div ref={setRef} className={classes.content}>
        <StickyHeader canShow={showStickyHeader} />
        <Header />
        <Fields />
      </div>
    </div>
  );
};

const useStyles = () => ({
  container: 'flex flex-col items-center', //h-[calc(100vh-200px)]',
  content: 'w-full max-w-[800px]',
});
